module.exports = __webpack_public_path__ + "img/A4-2-icon.55eee39a.png";